// SF 監査スケジュール API クライアント。
// GET/PUT/DELETE /sf/audit/schedule を呼び出してスケジュール設定を取得・更新・削除する。
// ApiClient に乗せることで認証・エラー正規化を委譲する。
import type { ApiClient } from "../api/client";

export interface ScheduleApiDeps {
  readonly apiClient: ApiClient;
}

// バックエンド /sf/audit/schedule のレスポンス型。
export interface ScheduleDto {
  readonly enabled: boolean;
  readonly frequency?: "weekly" | "monthly";
  readonly dayOfWeek?: number;
  readonly dayOfMonth?: number;
  readonly time?: string;
  readonly status?: string;
  readonly lastRunAt?: string;
}

// PUT /sf/audit/schedule のリクエストボディ型。
// 通知先はバックエンドがテナント管理者から解決するため、フロントは送信しない。
export interface SchedulePutBody {
  readonly frequency: "weekly" | "monthly";
  readonly dayOfWeek: number;
  readonly dayOfMonth: number;
  readonly time: string;
}

// GET /sf/audit/schedule → 現在のスケジュール設定を取得する。
export async function getSchedule(deps: ScheduleApiDeps): Promise<ScheduleDto> {
  return deps.apiClient.get<ScheduleDto>("/sf/audit/schedule");
}

// PUT /sf/audit/schedule → スケジュール設定を更新する。
export async function putSchedule(deps: ScheduleApiDeps, body: SchedulePutBody): Promise<ScheduleDto> {
  return deps.apiClient.put<ScheduleDto>("/sf/audit/schedule", body);
}

// DELETE /sf/audit/schedule → スケジュール設定を削除する（無効化）。
export async function deleteSchedule(deps: ScheduleApiDeps): Promise<ScheduleDto> {
  return deps.apiClient.del<ScheduleDto>("/sf/audit/schedule");
}
